// extracted by mini-css-extract-plugin
export default {"icon":"FormControls_icon__dgalG","visitControls":"FormControls_visitControls__6LDwA","recovery":"FormControls_recovery__D1C31","print":"FormControls_print__X6Z+R"};